import React, { PropsWithChildren, useMemo } from 'react'
import { Navigate } from 'react-router-dom'

import { useUser } from '@contexts'
import { RoleEnum } from '@types'

interface PrivateRoutesProps {
  allowedRoles: RoleEnum[]
}

const PrivateRoutes: React.FC<PropsWithChildren<PrivateRoutesProps>> = ({
  children,
  allowedRoles,
}) => {
  const { state: user } = useUser()

  const isRoleAllowed = useMemo(() => {
    const userRoles = user?.roles.map(role => role.name)

    if (!userRoles) return false

    return allowedRoles.some(role => userRoles.includes(role))
  }, [user, allowedRoles])

  return user && isRoleAllowed ? children : <Navigate to="/login" />
}

export default PrivateRoutes
